import { makeStyles } from "@mui/styles";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Theme,
  Typography,
} from "@mui/material";

const useStyles = makeStyles((theme: Theme) => ({
  cardHeader: { paddingBottom: 0 },
  setWidth: {
    [theme.breakpoints.up("sm")]: { width: 385 },
    [theme.breakpoints.down('sm')]: { width: "100%", textAlign: "left" },
    "& ul": {
      paddingLeft: 26,
      listStyleType: "disc",
      "& > li": { ...theme.typography.body1 },
    },
  },
}));

interface ITextPart {
  title: string;
  text: string[];
}

const TEXT_PARTS: ITextPart[] = [
  {
    title: "General",
    text: [
      "Starting read depth recommendations for standard profiling may be adjusted to increase panel sensitivity.",
      "Panels with over 7,000 primers require analysis using Archer<sup>\u00ae</sup> Analysis 7.0 or greater.",
    ],
  },
  {
    title: "For FusionPlex panels",
    text: [
      "Targeted Bases are estimated based on an average of 150bp input fragment size.",
      "Redundant known fusion partners will be deduplicated.",
    ],
  },
  {
    title: "For LiquidPlex panels",
    text: [
      "Targeted Bases are estimated based on an average of 125bp input fragment size.",
    ],
  },
];

const DesignAlerts = () => {
  const classes = useStyles();

  return (
    <Box component="section" mt={5}>
      <Card>
        <CardHeader
          className={classes.cardHeader}
          title="Design Considerations"
          titleTypographyProps={{
            component: "h3",
            variant: "h4",
            align: "center",
            color: "inherit",
          }}
        />
        <CardContent>
          {TEXT_PARTS.map((part, index) => (
            <Box
              key={index}
              mt={1}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Typography
                variant="h5"
                component="h4"
                className={classes.setWidth}
              >
                {part.title}
              </Typography>
              <Box className={classes.setWidth} mt={1}>
                <ul>
                  {part.text.map((text, idx) => (
                    <li key={idx} dangerouslySetInnerHTML={{ __html: text }} />
                  ))}
                </ul>
              </Box>
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
};

export default DesignAlerts;
